var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm._l(_vm.list, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "itemBox" },
          [
            _vm.show
              ? _c("AppArea", {
                  attrs: { clearable: "", level: 1 },
                  on: {
                    handleClose: function ($event) {
                      return _vm.handleClose(index)
                    },
                  },
                  model: {
                    value: item.districtName,
                    callback: function ($$v) {
                      _vm.$set(item, "districtName", $$v)
                    },
                    expression: "item.districtName",
                  },
                })
              : _vm._e(),
            _c("el-input", {
              staticStyle: { width: "260px", "margin-left": "5px" },
              attrs: { placeholder: "请输入详细信息" },
              model: {
                value: item.address,
                callback: function ($$v) {
                  _vm.$set(
                    item,
                    "address",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "item.address",
              },
            }),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.list.length > 1 || index,
                  expression: "list.length > 1 || index",
                },
              ],
              staticClass: "el-icon-minus addIcon",
              on: {
                click: function ($event) {
                  return _vm.handleDelete(index)
                },
              },
            }),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: index === _vm.list.length - 1,
                  expression: "index === list.length - 1",
                },
              ],
              staticClass: "el-icon-plus addIcon",
              on: { click: _vm.handleAdd },
            }),
          ],
          1
        )
      }),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.list.length,
            expression: "!list.length",
          },
        ],
        staticClass: "el-icon-plus addIcon",
        on: { click: _vm.handleAdd },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }